module.exports = __webpack_public_path__ + "static/media/logo-morros.1597d69f.png";